

/* ===============================
   Cart Drawer (theme.js's window.cart is never
   initialized on this site, since the active header
   section doesn't satisfy theme.js's Header class
   requirements). Provide a small standalone
   open/refresh/toggle implementation instead.
=============================== */
(function () {
  function getDrawer() {
    return document.getElementById("cart-drawer");
  }

  function ensureDrawerLoaded() {
    var drawer = getDrawer();
    if (drawer && !drawer.querySelector("[data-items-holder]")) {
      var tpl = drawer.querySelector("template[data-cart-drawer-template]");
      if (tpl) drawer.innerHTML = tpl.innerHTML;
    }
  }

  function formatCartMoney(cents) {
    if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
      var format = (window.theme && window.theme.currency_code_enable)
        ? window.theme.moneyWithCurrencyFormat
        : window.theme.moneyFormat;
      return Shopify.formatMoney(cents, format);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || navigator.language || "en-US", {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD"
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return "$" + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function getLineProperty(item, name) {
    var props = item && item.properties;
    if (!props) return "";
    if (Array.isArray(props)) {
      var found = props.find(function (prop) { return prop && prop[0] === name; });
      return found ? found[1] : "";
    }
    return props[name] || "";
  }

  function getVisibleDrawerState(fallbackCart) {
    var items = document.querySelectorAll("#cart-drawer [data-cart-item]");
    var count = 0;
    var subtotal = 0;

    items.forEach(function (item) {
      var qtyInput = item.querySelector("[data-quantity-field]");
      var qtyNum = item.querySelector(".cp-qty-num");
      var qty = parseInt(qtyInput && qtyInput.value, 10) || parseInt(qtyNum && qtyNum.textContent, 10) || 1;
      var priceCol = item.querySelector("[data-price-key]");
      var unit = priceCol
        ? (Number(priceCol.getAttribute("data-unit-cents")) || 0) +
          (Number(priceCol.getAttribute("data-pair-cents")) || 0) +
          (Number(priceCol.getAttribute("data-ts-cents")) || 0)
        : 0;

      count += qty;
      subtotal += unit * qty;
    });

    if (!items.length && fallbackCart) {
      count = fallbackCart.item_count || 0;
      subtotal = fallbackCart.total_price || 0;
    }

    return { count: count, subtotal: subtotal };
  }

  function getOrphanSpoolingKeys(cart) {
    if (!cart || !cart.items) return [];

    return cart.items.reduce(function (keys, item) {
      var spooledOnto = getLineProperty(item, "Spooled onto");
      var topshotFor = getLineProperty(item, "Topshot for");
      var target = spooledOnto || topshotFor;
      var lsKey = getLineProperty(item, "_ls_key");

      if (!target) return keys;

      var parentExists = cart.items.some(function (candidate) {
        if (candidate.key === item.key) return false;
        if (candidate.product_title !== target) return false;
        if (getLineProperty(candidate, "Spooled onto") || getLineProperty(candidate, "Topshot for")) return false;

        var candidateLsKey = getLineProperty(candidate, "_ls_key");
        return !lsKey || candidateLsKey === lsKey;
      });

      if (!parentExists) keys.push(item.key);
      return keys;
    }, []);
  }

  function updateFreeShippingMessage(cart) {
    var drawer = getDrawer();
    var message = drawer ? drawer.querySelector("[data-cart-message]") : document.querySelector("[data-cart-message]");
    if (!message) return;

    var limit = Number(message.getAttribute("data-limit")) || 0;
    var visibleState = getVisibleDrawerState(cart);
    var subtotal = visibleState.subtotal;
    var itemCount = visibleState.count;
    var progressBars = message.querySelectorAll("[data-cart-message-progress]");
    var leftToSpend = message.querySelector("[data-left-to-spend]");
    var defaultMessage = message.querySelector("[data-message-default]");
    var successMessage = message.querySelector(".cart__message__success");
    var qualified = limit > 0 && subtotal >= limit * 100;
    var percent = limit > 0 ? Math.min(100, Math.round((subtotal / (limit * 100)) * 100)) : 0;

    message.classList.toggle("is-success", qualified);
    message.classList.remove("is-hidden");

    if (defaultMessage) defaultMessage.classList.toggle("is-hidden", qualified);
    if (successMessage) {
      successMessage.classList.toggle("is-hidden", !qualified);
      if (qualified) successMessage.textContent = "You've unlocked FREE shipping! Your order ships free";
    }

    if (leftToSpend) {
      leftToSpend.innerHTML = formatCartMoney(Math.max(0, limit * 100 - subtotal)).replace(".00", "");
    }

    progressBars.forEach(function (progress) {
      var holder = progress.closest(".cart__message__progress__holder");
      progress.max = 100;
      progress.value = percent;
      progress.setAttribute("value", percent);
      progress.style.setProperty("--progress-width", percent + "%");
      if (holder) holder.style.setProperty("--progress-width", percent + "%");
    });
  }

  function refreshCartDrawerContents(skipOrphanCleanup) {
    hideCartError();
    return fetch("/cart?section_id=api-cart-items")
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var itemsHolder = document.querySelector("[data-items-holder]");
        var pairHolder = document.querySelector("[data-pair-products-holder]");
        var apiLineItems = doc.querySelector("[data-api-line-items]");
        var apiUpsellItems = doc.querySelector("[data-api-upsell-items]");

        if (itemsHolder) itemsHolder.innerHTML = apiLineItems ? apiLineItems.innerHTML : "";
        if (pairHolder) pairHolder.innerHTML = apiUpsellItems ? apiUpsellItems.innerHTML : "";

        return fetch("/cart.js");
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!skipOrphanCleanup) {
          var orphanKeys = getOrphanSpoolingKeys(cart);
          if (orphanKeys.length) {
            return removeSpooling(orphanKeys).then(function () {
              return refreshCartDrawerContents(true);
            });
          }
        }

        var itemsHolder = document.querySelector("[data-items-holder]");
        var emptyMessage = document.querySelector("[data-empty-message]");
        var footHolder = document.querySelector("[data-foot-holder]");
        var qtyEl = document.querySelector("[data-cart-items-qty]");
        var subtotalLabel = document.querySelector("[data-cart-subtotal-label]");
        var priceEls = document.querySelectorAll("[data-cart-total-price]");
        var totalEls = document.querySelectorAll("[data-cart-estimated-total]");
        var shippingRows = document.querySelectorAll("[data-cart-shipping-row]");
        var shippingRow = shippingRows[0];
        var shippingMessage = document.querySelector("#cart-drawer [data-cart-message]");
        var savingsRows = document.querySelectorAll("[data-cart-savings-row]");
        var savingsEls = document.querySelectorAll("[data-cart-savings]");
        var spoolingRows = document.querySelectorAll("[data-cart-spooling-row]");
        var visibleState = getVisibleDrawerState(cart);
        var count = visibleState.count;
        var freeShippingLimit = shippingMessage ? Number(shippingMessage.getAttribute("data-limit")) || 0 : 0;
        if (!freeShippingLimit && shippingRow) freeShippingLimit = Number(shippingRow.getAttribute("data-free-shipping-limit")) || 0;
        var isFreeShipping = freeShippingLimit > 0 && visibleState.subtotal >= freeShippingLimit * 100;
        var formattedTotal = formatCartMoney(visibleState.subtotal);

        if (itemsHolder) itemsHolder.classList.toggle("hidden", count === 0);
        if (emptyMessage) emptyMessage.classList.toggle("hidden", count > 0);
        if (footHolder) footHolder.classList.toggle("hidden", count === 0);
        shippingRows.forEach(function (row) { row.classList.toggle("hidden", isFreeShipping); });
        if (subtotalLabel) subtotalLabel.textContent = "Subtotal (" + count + " item" + (count === 1 ? "" : "s") + ")";

        if (qtyEl) {
          qtyEl.textContent = count + " item" + (count === 1 ? "" : "s");
          qtyEl.classList.toggle("hidden", count === 0);
        }

        priceEls.forEach(function (el) { el.innerHTML = formattedTotal; });
        totalEls.forEach(function (el) { el.innerHTML = formattedTotal; });

        var savingsAmount = (cart.original_total_price || 0) - (cart.total_price || 0);
        var hasSavings = savingsAmount > 0;
        savingsRows.forEach(function (row) { row.classList.toggle("hidden", !hasSavings); });
        if (hasSavings) {
          var formattedSavings = "−" + formatCartMoney(savingsAmount);
          savingsEls.forEach(function (el) { el.innerHTML = formattedSavings; });
        }

        var hasSpooling = cart.items.some(function (item) {
          return !!(getLineProperty(item, "Spooled onto") || getLineProperty(item, "Topshot for"));
        });
        spoolingRows.forEach(function (row) { row.classList.toggle("hidden", !hasSpooling); });

        updateFreeShippingMessage(cart);

        return cart;
      });
  }

  function updateCartLine(lineKey, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (body) {
        throw new Error(body.description || body.message || "Cart update failed");
      });
      return r.json();
    });
  }

  function showCartError(message) {
    var errorsBox = document.querySelector("[data-cart-errors]");
    var errorMessage = errorsBox && errorsBox.querySelector("[data-error-message]");
    if (errorMessage) errorMessage.textContent = message;
    if (errorsBox) errorsBox.classList.add("is-expanded");
  }

  function hideCartError() {
    var errorsBox = document.querySelector("[data-cart-errors]");
    if (errorsBox) errorsBox.classList.remove("is-expanded");
  }

  function removeSpooling(keys) {
    var updates = {};
    keys.forEach(function (key) {
      if (key) updates[key] = 0;
    });

    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error("Spooling update failed");
      return r.json();
    });
  }

  function clearSpoolingPropsFromLine(lineKey) {
    return fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (item) { return item.key === lineKey; });
        if (!line) return null;

        var rawProps = line.properties || {};
        var hasSpoolProps = Object.prototype.hasOwnProperty.call(rawProps, "Line Spooling") ||
          Object.prototype.hasOwnProperty.call(rawProps, "_ls_key");
        if (!hasSpoolProps) return null;

        var remainingProps = {};
        Object.keys(rawProps).forEach(function (key) {
          if (key !== "Line Spooling" && key !== "_ls_key" && rawProps[key] != null && rawProps[key] !== "") {
            remainingProps[key] = rawProps[key];
          }
        });

        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        }).then(function (r) {
          if (!r.ok) throw new Error("Failed to remove spooled line for re-add");
          return fetch("/cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({
              items: [{ id: line.variant_id, quantity: line.quantity, properties: remainingProps }]
            })
          });
        }).then(function (r) {
          if (!r.ok) throw new Error("Failed to re-add reel without spooling properties");
          return r.json();
        });
      });
  }

  function openCartDrawer() {
    ensureDrawerLoaded();
    return refreshCartDrawerContents().then(function () {
      var drawer = getDrawer();
      if (drawer) {
        document.body.classList.add("js-drawer-open-cart");
        drawer.classList.remove("cv-h");
        drawer.classList.add("is-open");
      }
    });
  }

  function closeCartDrawer() {
    var drawer = getDrawer();
    document.body.classList.remove("js-drawer-open-cart");
    if (drawer) drawer.classList.remove("is-open");
  }

  document.addEventListener("click", function (e) {
    var target = e.target && e.target.closest ? e.target : e.target.parentElement;
    var toggle = target && target.closest("[data-cart-drawer-toggle]");
    var drawer = getDrawer();

    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      if (document.body.classList.contains("js-drawer-open-cart")) {
        closeCartDrawer();
      } else {
        openCartDrawer();
      }
      return;
    }

    var catchupSameBtn = target && target.closest(".ls-catchup-same");
    if (catchupSameBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      var catchupLineKey = catchupSameBtn.getAttribute("data-line-item-key");
      var catchupTargetQty = parseInt(catchupSameBtn.getAttribute("data-target-qty"), 10);
      if (!catchupLineKey || !catchupTargetQty) return;

      catchupSameBtn.disabled = true;
      catchupSameBtn.textContent = "Updating...";
      updateCartLine(catchupLineKey, catchupTargetQty)
        .then(refreshCartDrawerContents)
        .catch(function (err) {
          catchupSameBtn.disabled = false;
          catchupSameBtn.textContent = "Spool all reels with this line";
          showCartError(err && err.message ? err.message : "We couldn't update the spooling quantity.");
        });
      return;
    }

    var catchupDiffBtn = target && target.closest(".ls-catchup-different");
    if (catchupDiffBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      if (typeof window._lsOpenForReelChangeLine !== "function") return;
      var catchupVariantId = catchupDiffBtn.getAttribute("data-reel-variant-id");
      var catchupLineKey = catchupDiffBtn.getAttribute("data-reel-line-key");
      var catchupCurrentQty = catchupDiffBtn.getAttribute("data-reel-current-qty");
      var catchupSplitQty = catchupDiffBtn.getAttribute("data-split-qty");
      var catchupTitle = catchupDiffBtn.getAttribute("data-reel-title");

      window._lsOpenForReelChangeLine(catchupLineKey, catchupCurrentQty, catchupSplitQty, catchupVariantId, catchupTitle);
      return;
    }

    var removeSpoolingBtn = target && target.closest(".ls-group__remove");
      if (removeSpoolingBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        var keys = (removeSpoolingBtn.getAttribute("data-paired-keys") || "")
          .split(",")
          .map(function (key) { return key.trim(); })
          .filter(Boolean);

        var reelArticle = removeSpoolingBtn.closest("[data-cart-item]");
        var reelKey = reelArticle ? reelArticle.getAttribute("data-item") : null;

        if (keys.length) {
          removeSpoolingBtn.disabled = true;
          removeSpoolingBtn.textContent = "Removing...";
          removeSpooling(keys)
            .then(function () {
              // The paired line-material row is gone, but the reel's own line
              // item still carries the "Line Spooling"/"_ls_key" properties
              // that described it (visible on checkout/order pages even though
              // this site's own cart UI doesn't render them). Shopify's cart API
              // can't edit a line's properties in place (they're baked into the
              // line's identity key) - the only way to clear them is to remove
              // the line and re-add it with the same variant/quantity/other
              // properties minus the spooling ones.
              return reelKey ? clearSpoolingPropsFromLine(reelKey) : null;
            })
            .then(refreshCartDrawerContents)
            .catch(function () {
              removeSpoolingBtn.disabled = false;
              removeSpoolingBtn.textContent = "Remove spooling";
            });
        }
        return;
      }

      var removeBtn = target && target.closest("[data-item-remove]");
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
        var removeItem = removeBtn.closest("[data-cart-item]");
        var pairedKeys = removeItem ? (removeItem.getAttribute("data-ls-paired-keys") || "")
          .split(",")
          .map(function (key) { return key.trim(); })
          .filter(Boolean) : [];
        var removeKeys = [removeBtn.getAttribute("data-id")].concat(pairedKeys).filter(Boolean);
        removeBtn.classList.add("is-loading");
        removeSpooling(removeKeys)
          .then(refreshCartDrawerContents)
          .catch(function () { removeBtn.classList.remove("is-loading"); });
        return;
      }

      var qtyBtn = target && target.closest(".cp-qty-btn");
      if (qtyBtn) {
        var qtyWrapper = qtyBtn.closest("[data-cp-qty]");
        var qtyInput = qtyWrapper && qtyWrapper.querySelector("[data-quantity-field]");
        var qtyNum = qtyWrapper && qtyWrapper.querySelector(".cp-qty-num");
        var lineKey = qtyInput && qtyInput.getAttribute("data-id");
        var current = parseInt(qtyInput && qtyInput.value, 10) || parseInt(qtyNum && qtyNum.textContent, 10) || 1;
        var dir = parseInt(qtyBtn.getAttribute("data-cp-dir"), 10) || 0;
        var maxAttr = qtyWrapper && qtyWrapper.getAttribute("data-cp-max");
        var max = maxAttr ? parseInt(maxAttr, 10) : null;
        var next = Math.max(1, current + dir);
        if (max && next > max) next = max;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        if (!lineKey || next === current) return;

        qtyBtn.disabled = true;
        if (qtyInput) qtyInput.value = next;
        if (qtyNum) qtyNum.textContent = next;

        updateCartLine(lineKey, next)
          .then(refreshCartDrawerContents)
          .catch(function (err) {
            if (qtyInput) qtyInput.value = current;
            if (qtyNum) qtyNum.textContent = current;
            showCartError(err && err.message ? err.message : "We couldn't update this item's quantity.");
          })
          .then(function () {
            qtyBtn.disabled = false;
          });
        return;
      }

    if (document.body.classList.contains("js-drawer-open-cart")) {
      if (drawer && !drawer.contains(e.target)) closeCartDrawer();
    }
  }, true);

  window.openCartDrawerAjax = openCartDrawer;
  window.closeCartDrawerAjax = closeCartDrawer;
})();

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".description-wrapper");
  const fade = document.querySelector(".fade-effect");
  const btn = document.querySelector(".see-more");
  const content = document.querySelector(".description-content");

  if (btn) {
    btn.addEventListener("click", function () {
      if (wrapper.classList.contains("expanded")) {
        // recolher
        wrapper.style.maxHeight = "80px";
        fade.style.opacity = "1";
        btn.innerHTML = 'SEE MORE <img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Icon.png?v=1759846338" alt="icon">';
        wrapper.classList.remove("expanded");
      } else {
        // expandir com altura real do conteúdo
        const fullHeight = content.scrollHeight + "px";
        wrapper.style.maxHeight = fullHeight;
        fade.style.opacity = "0";
        btn.innerHTML = 'SEE LESS <img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Icon_02069316-e02a-4567-9380-25df9d8ee1ae.png?v=1759847346" alt="icon">';
        wrapper.classList.add("expanded");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  /* ===============================
     Expansão da secção "Technical Details"
  =============================== */
  const wrapper = document.querySelector(".technical-details-wrapper");
  const fade = document.querySelector(".technical-details-box .fade-effect");
  const btn = document.getElementById("tech-btn");
  const content = document.querySelector(".technical-details-content");

  if (btn && wrapper && content) {
    btn.addEventListener("click", function () {
      if (wrapper.classList.contains("expanded")) {
        wrapper.style.maxHeight = "180px";
        fade.style.opacity = "1";
        btn.innerHTML = 'SEE MORE <img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Icon.png?v=1759846338" alt="icon">';
        wrapper.classList.remove("expanded");
      } else {
        wrapper.style.maxHeight = content.scrollHeight + "px";
        fade.style.opacity = "0";
        btn.innerHTML = 'SEE LESS <img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Icon_02069316-e02a-4567-9380-25df9d8ee1ae.png?v=1759847346" alt="icon">';
        wrapper.classList.add("expanded");
      }
    });
  }

  /* ===============================
     Variantes + Stock + Add to Cart
  =============================== */
  const locale = document.documentElement.lang || navigator.language || "en-US";
  const shopCurrency = "{{ shop.currency }}";
  function fallbackFormatMoney(cents) {
    try {
      const n = (Number(cents) || 0) / 100;
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: shopCurrency,
      }).format(n);
    } catch (e) {
      return (Number(cents) / 100).toFixed(2);
    }
  }
  const formatMoney =
    (window.Shopify && typeof Shopify.formatMoney === "function" && Shopify.formatMoney) ||
    (window.Currency && typeof Currency.formatMoney === "function" && Currency.formatMoney) ||
    fallbackFormatMoney;

  const productJson = document.querySelector('[id^="ProductJson-"]');
  if (!productJson) {
    console.warn("❌ Product JSON não encontrado");
    return;
  }
  const productData = JSON.parse(productJson.textContent);

  const invMapEl = document.querySelector('[id^="VariantInventory-"]');
  const invMap = invMapEl ? JSON.parse(invMapEl.textContent) : {};

  const hiddenInput = document.querySelector("#AddToCartForm input[name='id']");
  const priceEl = document.querySelector(".product-pricing");
  const finalPriceEl = document.querySelector(".final-price");
  const stockEl = document.querySelector(".stock");
  const stockMsgEl = document.querySelector(".stock-msg");
  const qtySelect = document.getElementById("Quantity");
  const addBtn = document.querySelector('#AddToCartForm button[type="submit"]');
  const addForms = document.querySelectorAll('form[action="/cart/add"]');
  const suggestedForms = document.querySelectorAll(".SuggestedProductsForm");

  const variantSelects = [1, 2, 3].map((i) => document.getElementById(`Option${i}`)).filter(Boolean);

  function toggleAddToCart(isAvailable) {
    if (!addBtn) return;

    addBtn.disabled = !isAvailable;
    addBtn.classList.toggle("is-disabled", !isAvailable);
    addBtn.setAttribute("aria-disabled", String(!isAvailable));

    if (isAvailable) {
      addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Group_1.png?v=1759766296" alt="Cart" style="width:22px;height:22px;margin-right:6px;vertical-align:middle;"> Add to Cart`;
    } else {
      addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Group_1.png?v=1759766296" alt="Out of stock" style="width:22px;height:22px;margin-right:6px;vertical-align:middle;"> Out of Stock`;
    }
  }

  function renderPrices(variant) {
    if (!priceEl) return;
    const hasCompare = variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price);

    priceEl.innerHTML = hasCompare
      ? `
        <span class="sale-price">${formatMoney(variant.price)}</span>
        <span class="old-price">${formatMoney(variant.compare_at_price)}</span>
        <span class="discount">
          ${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}% off
        </span>`
      : `<span class="regular-price">${formatMoney(variant.price)}</span>`;

    // antigo sistema de final price (mantemos mas o novo vai por cima)
    updateFinalPrice(variant.price);
  }

  function getMaxQtyFor(variant) {
    const rec = invMap[String(variant.id)];
    if (rec && rec.tracked === false) return 10;
    if (rec && rec.policy === "continue") return 10;
    if (rec && typeof rec.qty === "number") return Math.max(0, rec.qty);
    if (typeof variant.inventory_quantity === "number") {
      return Math.max(0, variant.inventory_quantity);
    }
    return 0;
  }

  function renderQuantity(variant) {
    if (!qtySelect) return;
    qtySelect.innerHTML = "";

    const maxQty = getMaxQtyFor(variant);

    if (maxQty <= 0) {
      qtySelect.disabled = true;
      const opt = document.createElement("option");
      opt.value = 0;
      opt.textContent = "Out of stock";
      opt.disabled = true;
      qtySelect.appendChild(opt);
    } else {
      qtySelect.disabled = false;
      for (let i = 1; i <= maxQty; i++) {
        const opt = document.createElement("option");
        opt.value = i;
        opt.textContent = i;
        qtySelect.appendChild(opt);
      }
      qtySelect.value = 1;
    }
  }

  function renderStock(variant) {
    const rec = invMap[String(variant.id)];
    const tracked = rec ? rec.tracked : true;
    const policy = rec ? rec.policy : "deny";
    const qty = rec && typeof rec.qty === "number" ? rec.qty : variant.inventory_quantity;

    let inStock = false;
    if (!tracked) inStock = true;
    else if (policy === "continue") inStock = true;
    else inStock = qty > 0;

    if (stockEl) {
      stockEl.textContent = inStock ? "✔ In stock" : "❌ Out of stock";
      stockEl.classList.toggle("in-stock", inStock);
      stockEl.classList.toggle("out-of-stock", !inStock);
    }

    if (stockMsgEl) {
      if (inStock && qty > 0) {
        stockMsgEl.textContent = `Only ${qty} left in stock — order soon.`;
        stockMsgEl.style.display = "";
      } else {
        stockMsgEl.textContent = "";
        stockMsgEl.style.display = "none";
      }
    }

    toggleAddToCart(inStock);
    renderQuantity(variant);
  }

  // ANTIGO (ainda usado por updateVariant uma vez, mas o novo cálculo vai sobrepor)
  function updateFinalPrice(basePrice) {
    const qtyEl = document.querySelector("#Quantity");
    const finalPriceEl = document.querySelector(".jh-final-price");
    const suggestedForms = document.querySelectorAll(".SuggestedProductsForm");

    if (!finalPriceEl || !qtyEl) return;

    const qty = parseInt(qtyEl.value, 10) || 1;

    let total = basePrice * qty; // basePrice em cents



    finalPriceEl.textContent = formatMoney(total);
  }

  function updateVariant() {
    let variant;
    if (variantSelects.length > 0) {
      const selectedOptions = variantSelects.map((s) => s.value.trim());
      variant = productData.variants.find((v) =>
        v.options.every((opt, i) => opt.trim() === selectedOptions[i])
      );
    } else {
      variant = productData.variants[0];
    }

    if (!variant) {
      console.warn("⚠️ Nenhuma variante encontrada.");
      return;
    }

    if (hiddenInput) hiddenInput.value = variant.id;
    renderPrices(variant);
    renderStock(variant);

    // o novo sistema volta a calcular logo de seguida
    setTimeout(updateFinalPriceFromDOM, 0);

    const mainImg = document.querySelector("#MainProductImage img");
    if (mainImg && variant.featured_image && variant.featured_image.src) {
      const src = variant.featured_image.src.replace(/^\/\//, "https://");
      mainImg.src = src;
      mainImg.srcset = "";
    }
  }

  /* ===============================
     Eventos
  =============================== */
  variantSelects.forEach((select) => select.addEventListener("change", updateVariant));

  /*if (suggestedForm) {
    suggestedForm.addEventListener("change", () => {
      setTimeout(updateFinalPriceFromDOM, 0);
    });
  }*/

addForms.forEach(addForm => {
  addForm.addEventListener("submit", async function (e) {
    e.preventDefault();

    try {
      const items = [];

      // 👉 PRODUTO PRINCIPAL
      const formData = new FormData(addForm);

      let mainId = formData.get("id");

      // 🔥 FIX CRÍTICO (fallback)
      if (!mainId) {
        const hidden = addForm.querySelector('input[name="id"]');
        if (hidden) mainId = hidden.value;
      }

      const qty = parseInt(formData.get("quantity"), 10) || 1;

      if (!mainId) {
        console.error("❌ MAIN ID MISSING");
        return;
      }

      items.push({
        id: mainId,
        quantity: qty
      });

      // 👉 SUGERIDOS
      const addedVariants = new Set();

      document.querySelectorAll(".suggested-item").forEach(item => {
       if (item.offsetParent === null) return;

        const input = item.querySelector("input[type='checkbox']");
        if (!input || !input.checked) return;

        const variantId = input.value;

        if (addedVariants.has(variantId)) return;
        addedVariants.add(variantId);

        items.push({
          id: variantId,
          quantity: 1
        });
      });

      console.log("✅ FINAL ITEMS:", items);

      // 👉 REQUEST PARA SHOPIFY
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json" // 🔥 importante
        },
        body: JSON.stringify({ items })
      });

      const data = await res.json();
      console.log("🛒 SUCCESS:", data);

      // 👉 abre o cart drawer (se habilitado), senão volta ao /cart
      if (window.theme && window.theme.settings && window.theme.settings.cartType === "drawer") {
        window.openCartDrawerAjax();
      } else {
        window.location.href = "/cart";
      }

    } catch (err) {
      console.error("❌ ERROR:", err);
    }
  });
});

  // inicial
  updateVariant();
});



document.addEventListener("DOMContentLoaded", function() {
  const variantRows = document.querySelectorAll('.cstm_variant_row');
  const finalPriceEl = document.querySelector('.final-price');
  const stockMsgEl = document.querySelector('.stock-msg');
  const addToCartForm = document.querySelector('#AddToCartForm input[name="id"]');
  const variantBox = document.querySelector('.cstm_variant_box');

  // Get inventory map for stock calculations
  const invMapEl = document.querySelector('[id^="VariantInventory-"]');
  const invMap = invMapEl ? JSON.parse(invMapEl.textContent) : {};

  // Get product data for variant information
  const productJson = document.querySelector('[id^="ProductJson-"]');
  const productData = productJson ? JSON.parse(productJson.textContent) : { variants: [] };

  // Define formatMoney function for this scope
  const locale = document.documentElement.lang || navigator.language || "en-US";
  const shopCurrency = "{{ shop.currency }}";
  function fallbackFormatMoney(cents) {
    try {
      const n = (Number(cents) || 0) / 100;
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: shopCurrency,
      }).format(n);
    } catch (e) {
      return (Number(cents) / 100).toFixed(2);
    }
  }
  const formatMoney =
    (window.Shopify && typeof Shopify.formatMoney === "function" && Shopify.formatMoney) ||
    (window.Currency && typeof Currency.formatMoney === "function" && Currency.formatMoney) ||
    fallbackFormatMoney;

  variantRows.forEach((row, index) => {
    if(index === 0) row.classList.add('first-variant');

    row.addEventListener('click', function() {
      // First variant toggles collapse
      if(this.classList.contains('first-variant')) {
        variantBox.classList.toggle('collapsed');
      }

      // Remove active class from all
      variantRows.forEach(r => r.classList.remove('active'));
      this.classList.add('active');

      const price = this.getAttribute('data-price');
      const priceRaw = parseFloat(this.getAttribute('data-price-raw'));
      const compareRaw = parseFloat(this.getAttribute('data-compare-raw'));
      const stock = this.getAttribute('data-stock') === 'true';
      const variantId = this.getAttribute('data-id');

      // sincroniza id do formulário
      addToCartForm.value = variantId;

      // Também actualiza o input hidden principal
      const hiddenInput = document.querySelector("#AddToCartForm input[name='id']");
      if (hiddenInput) {
        hiddenInput.value = variantId;
      }

      // Get stock quantity for this variant using inventory map
      const variantData = productData.variants.find(v => v.id == variantId);
      const rec = invMap[String(variantId)];
      const tracked = rec ? rec.tracked : true;
      const policy = rec ? rec.policy : "deny";
      const qty = rec && typeof rec.qty === "number" ? rec.qty : (variantData ? variantData.inventory_quantity || 0 : 0);

      let inStock = false;
      if (!tracked) inStock = true;
      else if (policy === "continue") inStock = true;
      else inStock = qty > 0;

      // Update stock message dynamically
      if (stockMsgEl) {
        if (inStock && qty > 0) {
          stockMsgEl.textContent = `Only ${qty} left in stock — order soon!`;
          stockMsgEl.style.display = "";
        } else if (inStock) {
          stockMsgEl.textContent = "In stock — order soon!";
          stockMsgEl.style.display = "";
        } else {
          stockMsgEl.textContent = "Currently out of stock.";
          stockMsgEl.style.display = "";
        }
      }

      // Update add to cart button based on stock
      const addBtn = document.querySelector('#AddToCartForm button[type="submit"]');
      if (addBtn) {
        if (inStock) {
          addBtn.disabled = false;
          addBtn.classList.remove("is-disabled");
          addBtn.setAttribute("aria-disabled", "false");
          addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Group_1.png?v=1759766296" alt="Cart" style="width:22px;height:22px;margin-right:6px;vertical-align:middle;"> Add to Cart`;
        } else {
          addBtn.disabled = true;
          addBtn.classList.add("is-disabled");
          addBtn.setAttribute("aria-disabled", "true");
          addBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Group_1.png?v=1759766296" alt="Out of stock" style="width:22px;height:22px;margin-right:6px;vertical-align:middle;"> Out of Stock`;
        }
      }

      // Fix: Update quantity box with correct stock for selected variant
      const qtySelect = document.getElementById("Quantity");
      if (qtySelect) {
        qtySelect.innerHTML = "";

        // Use the same inventory data as above
        const rec2 = invMap[String(variantId)];
        const tracked2 = rec2 ? rec2.tracked : true;
        const policy2 = rec2 ? rec2.policy : "deny";
        const qty2 = rec2 && typeof rec2.qty === "number" ? rec2.qty : (variantData ? variantData.inventory_quantity || 0 : 0);

        let inStock2 = false;
        if (!tracked2) inStock2 = true;
        else if (policy2 === "continue") inStock2 = true;
        else inStock2 = qty2 > 0;

        if (!inStock2 || qty2 <= 0) {
          qtySelect.disabled = true;
          const opt = document.createElement("option");
          opt.value = 0;
          opt.textContent = "Out of stock";
          opt.disabled = true;
          qtySelect.appendChild(opt);
        } else {
          qtySelect.disabled = false;
          const maxQtyToShow = Math.min(qty2, 10); // Limit to 10 for UI
          for (let i = 1; i <= maxQtyToShow; i++) {
            const opt = document.createElement("option");
            opt.value = i;
            opt.textContent = i;
            qtySelect.appendChild(opt);
          }
          qtySelect.value = 1;
        }
      }

      // Update the main product pricing display to match the selected variant (antigo)
      const priceContainer = document.querySelector(".product-pricing");
      if (priceContainer) {
        const hasCompare = compareRaw > priceRaw;
        priceContainer.innerHTML = hasCompare
          ? `
            <span class="sale-price">${formatMoney(priceRaw)}</span>
            <span class="old-price">${formatMoney(compareRaw)}</span>
            <span class="discount">
              ${Math.round(((compareRaw - priceRaw) / compareRaw) * 100)}% off
            </span>`
          : `<span class="regular-price">${formatMoney(priceRaw)}</span>`;
      }

      // novo sistema: recalcular final price com qty + sugeridos
      setTimeout(updateFinalPriceFromDOM, 0);
    });
  });

  // Keep collapsed by default
  if (variantBox) variantBox.classList.add('collapsed');
});


document.addEventListener("DOMContentLoaded", function () {
  var viewedProducts = JSON.parse(localStorage.getItem("viewedProducts")) || [];
  var currentProduct = {
    handle: "{{ product.handle }}",
    title: "{{ product.title | escape }}",
    image: "{{ product.featured_image | image_url: width: 300 }}",
    price: "{{ product.price | money }}",
    url: "{{ product.url }}"
  };

  // Remove if already exists
  viewedProducts = viewedProducts.filter(p => p.handle !== currentProduct.handle);
  // Add at the beginning
  viewedProducts.unshift(currentProduct);
  // Keep only last 6
  if (viewedProducts.length > 6) viewedProducts.pop();

  localStorage.setItem("viewedProducts", JSON.stringify(viewedProducts));
});



document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".product-highlights");
  const toggle = section?.querySelector(".highlights-toggle");
  const list = section?.querySelector(".highlight-list");

  function isMobile() {
    return window.innerWidth <= 720;
  }

  function applyCollapseBehavior() {
    if (!section || !list || !toggle) return;
    if (isMobile()) {
      list.style.display = "none";
      toggle.style.display = "block";
      section.classList.remove("active");
    } else {
      list.style.display = "flex";
      toggle.style.display = "none";
    }
  }

  applyCollapseBehavior();
  window.addEventListener("resize", applyCollapseBehavior);

  if (toggle) {
    toggle.addEventListener("click", function () {
      section.classList.toggle("active");
      if (section.classList.contains("active")) {
        list.style.display = "flex";
        toggle.textContent = "–";
      } else {
        list.style.display = "none";
        toggle.textContent = "+";
      }
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".best-for");
  const toggle = section?.querySelector(".best-for-toggle");
  const tables = section?.querySelector(".best-for-tables");

  function isMobile() {
    return window.innerWidth <= 720;
  }

  function applyCollapseBehavior() {
    if (!section || !tables || !toggle) return;
    if (isMobile()) {
      tables.style.display = "none";
      toggle.style.display = "block";
      section.classList.remove("active");
    } else {
      tables.style.display = "flex";
      toggle.style.display = "none";
    }
  }

  applyCollapseBehavior();
  window.addEventListener("resize", applyCollapseBehavior);

  if (toggle) {
    toggle.addEventListener("click", function () {
      section.classList.toggle("active");
      if (section.classList.contains("active")) {
        tables.style.display = "flex";
        toggle.textContent = "–";
      } else {
        tables.style.display = "none";
        toggle.textContent = "+";
      }
    });
  }
});




document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".product-description-box");
  const toggle = section?.querySelector(".product-description-toggle");
  const tables = section?.querySelector(".mc");

  function isMobile() {
    return window.innerWidth <= 720;
  }

  function applyCollapseBehavior() {
    if (!section || !tables || !toggle) return;
    if (isMobile()) {
      tables.style.display = "none";
      toggle.style.display = "block";
      section.classList.remove("active");
    } else {
      tables.style.display = "block";
      toggle.style.display = "none";
    }
  }

  applyCollapseBehavior();
  window.addEventListener("resize", applyCollapseBehavior);

  if (toggle) {
    toggle.addEventListener("click", function () {
      section.classList.toggle("active");
      if (section.classList.contains("active")) {
        tables.style.display = "block";
        toggle.textContent = "–";
      } else {
        tables.style.display = "none";
        toggle.textContent = "+";
      }
    });
  }
});








document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".specifications:not(.escondermobile)");
  const toggle = section?.querySelector(".specifiations-toggle");
  const tables = section?.querySelector(".table-wrapper");

  function isMobile() {
    return window.innerWidth <= 720;
  }

  function applyCollapseBehavior() {
    if (!section || !toggle || !tables) return;
    if (isMobile()) {
      tables.style.display = "none";
      toggle.style.display = "block";
      section.classList.remove("active");
    } else {
      tables.style.display = "flex";
      toggle.style.display = "none";
    }
  }

  applyCollapseBehavior();
  window.addEventListener("resize", applyCollapseBehavior);

  if (toggle) {
    toggle.addEventListener("click", function () {
      section.classList.toggle("active");
      if (section.classList.contains("active")) {
        tables.style.display = "block";
        toggle.textContent = "–";
      } else {
        tables.style.display = "none";
        toggle.textContent = "+";
      }
    });
  }
});






document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".technical-details-box");
  const toggle = section?.querySelector(".technical-table-toggle");
  const tables = section?.querySelector(".technical-details-wrapper-main");

  function isMobile() {
    return window.innerWidth <= 720;
  }

  function applyCollapseBehavior() {
    if (!section || !toggle || !tables) return;
    if (isMobile()) {
      tables.style.display = "none";
      toggle.style.display = "block";
      section.classList.remove("active");
    } else {
      tables.style.display = "block";
      toggle.style.display = "none";
    }
  }

  applyCollapseBehavior();
  window.addEventListener("resize", applyCollapseBehavior);

  if (toggle) {
    toggle.addEventListener("click", function () {
      section.classList.toggle("active");
      if (section.classList.contains("active")) {
        tables.style.display = "block";
        toggle.textContent = "–";
      } else {
        tables.style.display = "none";
        toggle.textContent = "+";
      }
    });
  }
});



document.addEventListener("DOMContentLoaded", function() {
  // Add CSS for dropdown icon
  const style = document.createElement('style');
  style.textContent = `
    .select-wrapper {
      position: relative;
      display: inline-block;
    }

    .select-wrapper select {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background: transparent;
      padding-right: 30px;
      cursor: pointer;
    }

    .select-arrow {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      color: #666;
    }

    .select-wrapper select:focus + .select-arrow {
      color: #000;
    }
  `;
  document.head.appendChild(style);

  // Hide previously removed items on page load
  const removedItems = JSON.parse(localStorage.getItem('removedSuggestedItems') || '[]');
  const currentSuggestedItems = Array.from(document.querySelectorAll('.suggested-item')).map(item =>
    item.getAttribute('data-variant-id')
  );

  // Filter out removed items that are no longer in the current metafield
  const validRemovedItems = removedItems.filter(variantId =>
    currentSuggestedItems.includes(variantId)
  );

  // Update localStorage with only valid removed items
  localStorage.setItem('removedSuggestedItems', JSON.stringify(validRemovedItems));

  // Hide only the valid removed items and show items that are no longer removed
  validRemovedItems.forEach(variantId => {
    const item = document.querySelector(`.suggested-item[data-variant-id="${variantId}"]`);
    if (item) {
      item.style.display = 'none';
    }
  });

  // Show items that are no longer in the removed list (added back to metafield)
  currentSuggestedItems.forEach(variantId => {
    if (!validRemovedItems.includes(variantId)) {
      const item = document.querySelector(`.suggested-item[data-variant-id="${variantId}"]`);
      if (item) {
        item.style.display = '';
      }
    }
  });

  // Checkbox click -> só recalcula preço com helper
document.querySelectorAll(".checkbox-box").forEach(box => {
  box.addEventListener("click", function(e) {
    e.preventDefault();

    const parent = this.closest('.suggested-item');
    if (!parent) return;

    const input = parent.querySelector('input[type="checkbox"]');
    if (!input) return;

    // toggle
    input.checked = !input.checked;

    // sync atributo HTML
    if (input.checked) {
      input.setAttribute("checked", "checked");
    } else {
      input.removeAttribute("checked");
    }

    // sync UI
    this.classList.toggle("active", input.checked);

    // 🔥 FORÇA update SEM depender de events
    updateFinalPriceFromDOM();
  });
});
  // Remove link -> esconde item e recalcula
  document.querySelectorAll(".remove-link").forEach(link => {
  link.addEventListener("click", function(e) {
    e.preventDefault();

    const parentItem = this.closest(".suggested-item");
    if (!parentItem) return;

    const checkbox = parentItem.querySelector('input[type="checkbox"]');

    if (checkbox) {
      // 🔥 REMOVE estado JS
      checkbox.checked = false;

      // 🔥 REMOVE atributo HTML (IMPORTANTE)
      checkbox.removeAttribute("checked");
    }

    // 🔥 remove UI active
    const label = parentItem.querySelector('.checkbox-box');
    if (label) {
      label.classList.remove('active');
    }

    // 🔥 esconder
    parentItem.style.display = 'none';

    // 🔥 atualizar preço
    updateFinalPriceFromDOM();
  });
});
});








document.addEventListener("DOMContentLoaded", async function() {
  const container = document.querySelector('#recently-viewed-products');
  const wrapper = container.querySelector('.swiper-wrapper');
  const viewed = JSON.parse(localStorage.getItem('recently_viewed')) || [];

  if (viewed.length === 0) return;
  container.style.display = 'block';

  // Array to hold promises for product data fetching
  const productPromises = viewed.map(handle =>
    fetch(`/products/${handle}.js`)
      .then(res => {
        if (!res.ok) throw new Error(`Product not found for handle: ${handle}`);
        return res.json();
      })
      .catch(err => {
        console.warn("Failed to load product:", handle, err);
        return null; // Return null on error so the main loop can skip it
      })
  );

  // Wait for all product data to load
  const products = (await Promise.all(productPromises)).filter(p => p !== null);

  // Loop through successfully loaded products and render them
  products.forEach(product => {
    const hasCompare = product.compare_at_price > product.price;
    const comparePrice = hasCompare
      ? `<span class="compare-price" style="color:#4D6472;">$${(product.compare_at_price / 100).toFixed(2)}</span>`
      : '';
    const priceColor = hasCompare ? '#C1272D' : '#003F52';

    const colors = product.options.includes('Color')
      ? `<div class="color-swatches">${product.variants.map(v =>
          v.featured_image ? `<img src="${v.featured_image.src}" alt="${v.title}" class="swatch-img">` : ''
        ).join('')}</div>` : '';

    // Product card HTML
    wrapper.insertAdjacentHTML('beforeend', `
      <div class="swiper-slide">
        <div class="product-card">
          <div class="image-wrapper">
            <a href="${product.url}">
              <img src="${product.featured_image}" alt="${product.title}">
            </a>
            <div class="rating-box">
              <div class="yotpo bottomLine" data-product-id="${product.id}" style="display:flex;align-items:center;gap:6px;">
                </div>
            </div>
          </div>
          <div class="product-info">
            <h3 class="product-title">${product.title}</h3>
            <div class="price-box">
              <span class="current-price" style="color:${priceColor};">
                $${(product.price / 100).toFixed(2)}
              </span>
              ${comparePrice}
            </div>
            ${colors}
            <a href="${product.url}" class="shop-now-btn">
              <img src="https://cdn.shopify.com/s/files/1/0586/7601/9311/files/Group_1.png?v=1759766296" alt="icon" class="btn-icon">
              Shop Now
            </a>
          </div>
        </div>
      </div>
    `);
  });

  // Initialize Swiper
  new Swiper('.recently-viewed-swiper', {
    slidesPerView: 2,
    spaceBetween: 10,
    loop: false,
    grabCursor: true,
    breakpoints: {
      720: { slidesPerView: 4, spaceBetween: 15 },
      1024: { slidesPerView: 7, spaceBetween: 20 }
    }
  });

  // Smooth fade-in after images load
  const images = wrapper.querySelectorAll('img');
  let loadedCount = 0;
  function showContainer() {
    container.classList.add('loaded');
  }

  images.forEach(img => {
    if (img.complete) {
      loadedCount++;
    } else {
      img.onload = () => {
        loadedCount++;
        if (loadedCount === images.length) showContainer();
      };
    }
  });
  // Fallback and main trigger for visibility
  setTimeout(showContainer, 3000);

  // ---- Yotpo multi-widget fix (UPDATED) ----
  function refreshAllYotpoWidgets() {
    const yotpoWidgets = document.querySelectorAll('.yotpo.bottomLine');
    if (yotpoWidgets.length === 0) return; // Exit if no widgets are found

    function tryRefresh() {
      if (window.yotpo && typeof window.yotpo.refreshWidgets === "function") {
        console.log("✅ Global Yotpo refresh triggered.");
        window.yotpo.refreshWidgets();
      }
      else if (window.Yotpo && window.Yotpo.API) {
        console.log("✅ Individual Yotpo widget refresh triggered.");
        yotpoWidgets.forEach(el => {
          try {
            (new window.Yotpo.API(window.yotpo || {})).refreshWidgets({ selector: el });
          } catch (err) {
            console.warn("Yotpo refresh failed for element:", el, err);
          }
        });
      }
      else {
        console.log("⏳ Waiting for Yotpo to load...");
        if (typeof window._yotpoRetryCount === 'undefined') window._yotpoRetryCount = 0;
        if (window._yotpoRetryCount < 10) {
          window._yotpoRetryCount++;
          setTimeout(tryRefresh, 1000);
        } else {
          console.error("❌ Yotpo API did not load within the expected time.");
        }
      }
    }

    tryRefresh();
  }

  setTimeout(refreshAllYotpoWidgets, 500);
});








document.addEventListener("DOMContentLoaded", function() {
  const variantBox = document.querySelector('.cstm_variant_box');
  const variantRows = document.querySelectorAll('.cstm_variant_row');

  variantRows.forEach(row => {
    row.addEventListener('click', function() {
      const isFirst = row.classList.contains('first-variant');

      // Remove previous selected class
      variantRows.forEach(r => r.classList.remove('selected'));
      // Mark clicked variant as selected
      row.classList.add('selected');

      // Collapse dropdown if not first-variant
      if (!isFirst && variantBox) {
        variantBox.classList.add('collapsed');
      }

      // Scroll clicked variant into view (top)
      setTimeout(() => {
        row.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    });
  });
});



// ---------- NOVO SISTEMA CENTRAL DE PREÇO ----------

// Lê o preço unitário (em dólares) da variante actual
function getUnitPrice() {
  // 1 — variant row activa (se estiveres a usar a tabela custom)
  const activeRow = document.querySelector(".cstm_variant_row.active");
  if (activeRow) {
    const raw = parseFloat(activeRow.getAttribute("data-price-raw"));
    if (!isNaN(raw)) {
      // aqui normalmente é em cents; mas o DOM principal tem em dinheiro.
      // Vamos preferir o valor visual principal mais abaixo.
    }
  }

  // 2 — preço grande principal (headliner)
  let el = document.querySelector(".jh-main-price");
  if (el) {
    const val = parseFloat(el.textContent.replace(/[^0-9.]/g, ""));
    if (!isNaN(val)) return val;
  }

  // 3 — fallback: preço na trigger do selector de modelo
  el = document.querySelector(".js-jh-model-trigger-price");
  if (el) {
    const val = parseFloat(el.textContent.replace(/[^0-9.]/g, ""));
    if (!isNaN(val)) return val;
  }

  return null;
}

// Recalcula o preço final (preço x quantidade + sugeridos) e actualiza todas as spans
function updateFinalPriceFromDOM() {
  console.log("🔥 updateFinalPriceFromDOM RUNNING");
  const unit = getUnitPrice(); // dólares
  const finalEls = document.querySelectorAll(".final-price, .jh-final-price");
  const qtyEls = document.querySelectorAll('form[action*="/cart/add"] select[name="quantity"]');
  const suggestedForms = document.querySelectorAll(".SuggestedProductsForm");



  if (!finalEls.length || unit === null) return;

  // quantidade (se não houver select, assume 1)
  let qty = 1;
  if (qtyEls.length) {
    qty = parseInt(qtyEls[0].value, 10) || 1;

    // manter todos os selects de quantidade sincronizados
    qtyEls.forEach((sel, idx) => {
      if (idx > 0) sel.value = qty.toString();
    });
  }

  let total = unit * qty;

 const addedVariants = new Set();

document.querySelectorAll(".suggested-item").forEach(item => {
  // ignora escondidos (importantíssimo)
  if (item.style.display === 'none') return;
  if (item.offsetParent === null) return;

  const input = item.querySelector("input[type='checkbox']");
  if (!input) return;

  console.log("----");
  console.log("ID:", input.value);
  console.log("checked:", input.checked);
  console.log("dataset price:", input.dataset.price);

  if (!input.checked) {
    console.log("⛔ IGNORADO (não checked)");
    return;
  }

  const variantId = input.value;

  if (addedVariants.has(variantId)) return;
  addedVariants.add(variantId);

  const extraCents = parseInt(input.dataset.price, 10) || 0;

  console.log("✅ ADICIONADO:", variantId);
  console.log("💰 preço (cents):", extraCents);

  total += extraCents / 100;
});

const formatted = `$${total.toFixed(2)}`;

finalEls.forEach(el => {
  el.textContent = formatted;
});
}

// Liga eventos à quantidade e variantes
document.addEventListener("DOMContentLoaded", function() {
  // quantity change em TODOS os selects (mobile + desktop)
  document
    .querySelectorAll('form[action*="/cart/add"] select[name="quantity"]')
    .forEach(sel => {
      sel.addEventListener("change", function () {
        const val = this.value;
        // sincroniza todos
        document
          .querySelectorAll('form[action*="/cart/add"] select[name="quantity"]')
          .forEach(other => {
            other.value = val;
          });

        updateFinalPriceFromDOM();
      });
    });

  // também quando se clica numa row de variantes custom
  document.addEventListener("click", function(e) {
    if (e.target.closest(".cstm_variant_row")) {
      setTimeout(updateFinalPriceFromDOM, 50);
    }
  });

  // inicial
  updateFinalPriceFromDOM();
});


document.addEventListener("DOMContentLoaded", function () {
  const thumbSlider = document.querySelector('.thumb-slider');
  const mainSlider = document.querySelector('.main-slider');

  if (!thumbSlider || !mainSlider) {
    console.error('Sliders not found');
    return;
  }

  const thumbSwiper = new Swiper('.thumb-slider', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    watchSlidesProgress: true,
    navigation: { prevEl: '.thumb-nav--prev', nextEl: '.thumb-nav--next' },
  });
  window.thumbSwiper = thumbSwiper;

  window.mainSwiper = new Swiper('.main-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: thumbSwiper,
    }
  });

  console.log('✅ Swiper initialized correctly');
});



document.addEventListener("DOMContentLoaded", function () {
  const mobileStickyBar = document.getElementById("mobileStickyBar");

  if (!mobileStickyBar) return;

  window.addEventListener("scroll", () => {
    const rect = mobileStickyBar.getBoundingClientRect();

    if (rect.top <= 0) {
      mobileStickyBar.style.display = "none";
    } else {
      mobileStickyBar.style.display = "";
    }
  });
});








document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".js-jh-model-option");
  const tbody = document.getElementById("specs-body");
  const thead = document.getElementById("specs-head");

  function formatLabel(key) {
    return key.replaceAll("_", " ").replace(/\b\w/g, l => l.toUpperCase());
  }

  function renderSpecs(option) {
    let specs = {};

    try {
      specs = JSON.parse(option.getAttribute("data-specs") || "{}");
    } catch (e) {
      console.log("Erro specs:", e);
      return;
    }

    // 🔥 HEADER (ordem do metafield)
    let headHTML = "<tr><th>Model</th>";

    Object.keys(specs).forEach(key => {
      headHTML += `<th>${formatLabel(key)}</th>`;
    });

    headHTML += "</tr>";
    thead.innerHTML = headHTML;

    // 🔥 ROW (mesma ordem)
    let rowHTML = `<tr><td>${option.dataset.title}</td>`;

    Object.values(specs).forEach(value => {
      rowHTML += `<td>${value}</td>`;
    });

    rowHTML += "</tr>";
    tbody.innerHTML = rowHTML;
  }

  // inicial
  const active = document.querySelector(".js-jh-model-option.is-active");
  if (active) renderSpecs(active);

  // clique
  options.forEach(option => {
    option.addEventListener("click", function () {
      options.forEach(o => o.classList.remove("is-active"));
      this.classList.add("is-active");

      renderSpecs(this);
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".js-jh-model-option");
  const container = document.getElementById("mobile-specs");

  function formatLabel(key) {
    return key
      .replaceAll("_", " ")
      .replace(/\b\w/g, l => l.toUpperCase());
  }

  function renderMobileSpecs(option) {
    let specs = {};

    try {
      specs = JSON.parse(option.getAttribute("data-specs") || "{}");
    } catch (e) {
      console.log("Erro specs:", e);
      return;
    }

    let html = "";

    Object.entries(specs).forEach(([key, value]) => {
      html += `
        <div class="spec-item">
          <span class="spec-label">${formatLabel(key)}</span>
          <span class="spec-value">${value}</span>
        </div>
      `;
    });

    container.innerHTML = html;
  }

  // 🔹 inicial
  const active = document.querySelector(".js-jh-model-option.is-active");
  if (active) renderMobileSpecs(active);

  // 🔹 ao clicar
  options.forEach(option => {
    option.addEventListener("click", function () {
      renderMobileSpecs(this);
    });
  });
});

// Allow sibling-product color picker to trigger spec rendering via custom event
document.addEventListener('jh:specs-update', function(e) {
  var specs = e.detail && e.detail.specs ? e.detail.specs : {};
  var title = e.detail && e.detail.title ? e.detail.title : '';

  function fmt(key) { return key.replaceAll('_', ' ').replace(/\b\w/g, function(l) { return l.toUpperCase(); }); }

  var thead = document.getElementById('specs-head');
  var tbody = document.getElementById('specs-body');
  var mobileContainer = document.getElementById('mobile-specs');

  var keys = Object.keys(specs);

  if (thead && tbody) {
    if (keys.length) {
      var headHTML = '<tr><th>Model</th>';
      keys.forEach(function(k) { headHTML += '<th>' + fmt(k) + '</th>'; });
      thead.innerHTML = headHTML + '</tr>';
      var rowHTML = '<tr><td>' + title + '</td>';
      Object.values(specs).forEach(function(v) { rowHTML += '<td>' + v + '</td>'; });
      tbody.innerHTML = rowHTML + '</tr>';
    } else {
      thead.innerHTML = '';
      tbody.innerHTML = '';
    }
  }

  if (mobileContainer) {
    if (keys.length) {
      var mHTML = '';
      Object.entries(specs).forEach(function(pair) {
        mHTML += '<div class="spec-item"><span class="spec-label">' + fmt(pair[0]) + '</span><span class="spec-value">' + pair[1] + '</span></div>';
      });
      mobileContainer.innerHTML = mHTML;
    } else {
      mobileContainer.innerHTML = '';
    }
  }
  // Re-run section visibility (MutationObserver watches detached elements after SPA swap)
  window.dispatchEvent(new Event('jh:reinit-sections'));
});

document.addEventListener("DOMContentLoaded", function () {
  const options = document.querySelectorAll(".js-jh-model-option");

  function goToVariantImage(index) {
    if (!window.mainSwiper) {
      console.log("Swiper ainda não carregou");
      return;
    }

    if (index === undefined || index === null || index === "") return;

    window.mainSwiper.slideTo(Number(index));
  }

  options.forEach(option => {
    option.addEventListener("click", function () {
      const index = this.dataset.imageIndex;

      console.log("INDEX:", index);

      goToVariantImage(index);
    });
  });
});

/* -- Section visibility + mobile auto-expand -- */
document.addEventListener('DOMContentLoaded', function () {

  function isMobile() { return window.innerWidth <= 768; }

  function isOpen(btn) { return btn && btn.textContent.trim() === '-'; }

  function clickToOpen(btn) {
    if (btn && !isOpen(btn)) btn.click();
  }

  function applyAll() {
    var mobile = isMobile();
    var specItems = document.querySelectorAll('.technical-specs-mobile .spec-item');
    var hasSpecs  = specItems && specItems.length > 0;
    if (!hasSpecs) {
      var _activeOpt = document.querySelector('.js-jh-model-option.is-active') ||
                       document.querySelector('.jh-model-selector__option[aria-selected="true"]');
      if (_activeOpt) {
        try {
          var _sd = JSON.parse(_activeOpt.getAttribute('data-specs') || '{}');
          hasSpecs = _sd && typeof _sd === 'object' && Object.keys(_sd).length > 0;
        } catch(e) {}
      }
    }

    /* 1. HIGHLIGHTS */
    var hlWrapper = document.querySelector('.product-highlights');
    var hlList    = document.querySelector('.highlight-list');
    var hlToggle  = document.querySelector('.highlights-toggle');
    if (hlWrapper) {
      if (!hlList || hlList.children.length === 0) {
        hlWrapper.style.display = 'none';
      } else {
        hlWrapper.style.display = '';
        if (mobile) clickToOpen(hlToggle);
      }
    }

    /* 2. DESCRIPTION */
    var descWrapper = document.querySelector('.product-description-box');
    var descContent = document.querySelector('.description-content');
    var descToggle  = document.querySelector('.product-description-toggle');
    if (descWrapper) {
      if (!descContent || !descContent.innerHTML.trim()) {
        descWrapper.style.display = 'none';
      } else {
        descWrapper.style.display = '';
        if (mobile) clickToOpen(descToggle);
      }
    }

    /* 3. .specifications — always hidden (mobile uses .technical-details-box instead) */
    var specWrapper = document.querySelector('.specifications:not(.escondermobile)');
    if (specWrapper) {
      specWrapper.style.display = 'none';
    }

    /* 4. .technical-details-box — hidden on desktop, shown + expanded on mobile */
    var mWrapper = document.querySelector('.technical-details-box');
    var mToggle  = document.querySelector('.technical-table-toggle');
    if (mWrapper) {
      if (!mobile || !hasSpecs) {
        mWrapper.style.display = 'none';
      } else {
        mWrapper.style.display = '';
        clickToOpen(mToggle);
      }
    }

        /* DESKTOP SPECS (.specifications.escondermobile) — hide when empty */
        var desktopSpecWrapper = document.querySelector('.specifications.escondermobile');
        if (desktopSpecWrapper) {
          var dSpecsHead = document.getElementById('specs-head');
          var dSpecsBody = document.getElementById('specs-body');
          var hasDesktopSpecs = (dSpecsHead && dSpecsHead.children.length > 0) || (dSpecsBody && dSpecsBody.children.length > 0);
          desktopSpecWrapper.style.display = hasDesktopSpecs ? '' : 'none';
        }
  }

  applyAll();
  window.addEventListener('resize', applyAll);

  // Re-run applyAll when specs table updates (child product selection)
  var _specsBody = document.getElementById('specs-body');
  var _specsHead = document.getElementById('specs-head');
  var _mobileSpecs = document.getElementById('mobile-specs');
  if (_specsBody || _specsHead || _mobileSpecs) {
    var _specsMO = new MutationObserver(applyAll);
    if (_specsBody) _specsMO.observe(_specsBody, { childList: true, subtree: true });
    if (_specsHead) _specsMO.observe(_specsHead, { childList: true, subtree: true });
    if (_mobileSpecs) _specsMO.observe(_mobileSpecs, { childList: true, subtree: true });
  }
});
